'use client';

import { useAddressStore } from '@/entities/address/model/use-address-store';
import { toaster } from '@/shared/ui/toaster';
import ConfirmModal from '@/widgets/confirm-modal';
import { Center, Flex } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import AddressItem from './address-item';

const MyAddressesList = () => {
  const t = useTranslations('profile');
  const [addressId, setAddressId] = useState('');
  const { points, removePoint } = useAddressStore((state) => state);
  const onRemove = () => {
    removePoint(addressId);

    toaster.success({
      title: t('successfully_deleted_address'),
    });

    setAddressId('');
  };

  if (points.length === 0) {
    return <Center>No addresses</Center>;
  }

  return (
    <>
      <Flex direction="column">
        {points.map((address) => (
          <AddressItem
            key={address.id}
            address={address}
            onDelete={(id) => setAddressId(id)}
          />
        ))}
      </Flex>

      <ConfirmModal
        isOpen={Boolean(addressId)}
        onConfirm={onRemove}
        title={t('delete_address')}
        onClose={() => setAddressId('')}
        text={{ confirm: 'confirm', cancel: 'cancel' }}
        description={t('confirm_delete_address')}
      />
    </>
  );
};

export default MyAddressesList;
